
<div id="dpi" style="height: 1in; width: 1in; left: 100%; position: fixed; top: 100%;"></div>
<app-navbar> </app-navbar>
<div class="header-wrapper">
    <router-outlet class="full-size"></router-outlet>
</div>
